const work_immigration = `Finland needs people from other countries to come and work here. 
Some people think this is a good idea, and some don't. 
It's important to talk about it.
I think work-based immigration can help Finland in many ways. 
It can bring new ideas and skills to the country, helping it grow. 
It can also fill jobs that might be hard to fill with people already in Finland. 
This can make businesses stronger and help the economy.
But some people might worry about work-based immigration. 
They might think it could take jobs away from people already in Finland. 
They might also worry about people from other countries changing the Finnish way of life.
I think we can find a balance.
We can make sure that work-based immigration helps Finland grow without taking away jobs from people already here. 
We can also make sure that people coming to Finland learn about the Finnish way of life and respect it.
By working together, we can make sure that work-based immigration is good for everyone. 
It can help Finland become stronger and more diverse, while still keeping its identity and culture. `;

export default work_immigration;